import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import CommonChip from '../../../common_components/CommonChip';
import { getInitials, getAvatarColor } from '../shared';
const MAX_VISIBLE_CHIPS = 4;
export function isEmptyIcpValue(v) {
    if (v == null)
        return true;
    const s = String(v).trim();
    return s === '' || s.toLowerCase() === 'null';
}
const HandlerRow = (props) => {
    if (props.variant === 'icp' || props.variant === 'icp-stacked') {
        const { label, value } = props;
        const stacked = props.variant === 'icp-stacked';
        return (_jsxs(Box, { className: "active-client-handler-row", sx: {
                display: 'grid',
                gridTemplateColumns: stacked ? '1fr' : '1fr auto',
                alignItems: stacked ? 'flex-start' : 'center',
                gap: stacked ? '2px' : 1,
                py: '6px',
            }, children: [_jsx(Typography, { sx: {
                        fontSize: '12px',
                        color: '#344054',
                        fontWeight: 500,
                    }, children: label }), _jsx(Typography, { sx: {
                        fontSize: '12px',
                        color: '#667085',
                        fontWeight: 400,
                        textAlign: stacked ? 'left' : 'right',
                        wordBreak: 'break-word',
                    }, children: isEmptyIcpValue(value) ? '' : value })] }));
    }
    // Default: handler chips row
    const { label, users, icon } = props;
    const visibleUsers = users.slice(0, MAX_VISIBLE_CHIPS);
    const extraUsers = users.slice(MAX_VISIBLE_CHIPS);
    return (_jsxs(Box, { className: "active-client-handler-row", sx: {
            display: 'grid',
            gridTemplateColumns: 'auto minmax(0, 1fr) auto',
            alignItems: 'center',
            columnGap: '8px',
            py: '6px',
        }, children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'center', color: '#98A2B3', flexShrink: 0 }, children: icon }), _jsx(Typography, { sx: {
                    fontSize: '12px',
                    lineHeight: 1.4,
                    color: '#344054',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                }, children: label }), _jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    position: 'relative',
                    zIndex: 1,
                }, children: users.length > 0 ? (_jsxs(_Fragment, { children: [visibleUsers.map((u, i) => {
                            const color = getAvatarColor(i);
                            return (_jsx(CommonChip, { label: getInitials(u.name), tooltip: u.name, renderType: "circle", index: i, className: "circle manager-circle", sx: { background: color.bg, color: color.text } }, i));
                        }), extraUsers.length > 0 && (_jsx(CommonChip, { label: `+${extraUsers.length}`, renderType: "circle", className: "circle extra-circle manager-circle", index: visibleUsers.length, tooltip: _jsx(Box, { sx: {
                                    background: 'black',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    minWidth: 180,
                                }, children: extraUsers.map((u, idx) => (_jsx(Box, { sx: {
                                        px: 2,
                                        py: 1.2,
                                        fontSize: '14px',
                                        textTransform: 'capitalize',
                                        borderBottom: idx !== extraUsers.length - 1
                                            ? '1px solid rgba(255,255,255,0.5)'
                                            : 'none',
                                        color: '#ffffff',
                                    }, children: u.name }, `${u.name}-${idx}`))) }) }))] })) : (_jsx(Typography, { sx: { fontSize: '11px', color: '#98A2B3' }, children: "\u2014" })) })] }));
};
export default HandlerRow;
